import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(4)};
    text-align: center;

    h3,
    p {
      margin: 0;
    }

    p {
      margin-top: ${theme.spacing(1)};
      font-size: 1.8rem;
    }
  `}
`

const Content = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.5)};
    margin-top: ${theme.spacing(4)};

    & > * {
      display: grid;
      grid-template-columns: 1fr;
      align-items: center;
      padding: ${theme.spacing(1)} ${theme.spacing(2)};
      background-color: ${theme.palette.grey[300]};

      ${theme.media('sm')} {
        grid-template-columns: 14rem 1fr;
      }

      p {
        margin: 0;
        text-align: left;

        &:first-child {
          font-weight: bold;
          font-size: 1.6rem;
        }
      }
    }
  `}
`

const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${theme.spacing(1)};
    margin-top: ${theme.spacing(4)};

    > * {
      ${theme.maxMedia('xs')} {
        flex-grow: 1;
      }
    }
  `}
`

export default {
  Wrapper,
  Content,
  Actions,
}
